const apiEndpoint = `${process.env.REACT_APP_BASE_URI}`;
export const BASE_URL = process.env.REACT_APP_BASE || "http://3.224.229.28/";
export default apiEndpoint;
